// extracted by mini-css-extract-plugin
export default {"sobreContainer":"About_sobreContainer__yTD07","header":"About_header__3gBKW","cardGrid":"About_cardGrid__iwZI+","card":"About_card__z5Lla","icon":"About_icon__WD46d"};